var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{ref:"search",staticClass:"col-8 form-inline my-2 my-lg-0",attrs:{"id":"search"}},[_c('input',{staticClass:"col-12 form-control mr-sm-6 sb-search-input",attrs:{"type":"text","placeholder":"Search"}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6de52c16","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Header/SearchBar.vue
// module id = eB8y
// module chunks = 0